import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW2800Component } from './kymw2800.component';

import { OutputGPBudgetProgressFileService } from './api-services/output-gp-budget-progress-file.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

/**
 * 週別部門別供給高GP予算進捗画面 モジュール設定クラス
 *
 * @export KYMW2800Module
 * @class KYMW2800Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW2800Component,
  ],
  providers: [
    FileDownloadConfirmService,
    OutputGPBudgetProgressFileService
  ],
})

export class KYMW2800Module { }
